import PropTypes from 'prop-types'
import { BannerContainer, BannerItem, BannerImage } from './style'

const BannerGrid = ({ banners, onBannerClick }) => {
  const handleClick = (banner) => {
    if (banner.id) {
      onBannerClick(banner.id)
    }
  }

  return (
    <BannerContainer itemCount={banners.length}>
      {banners.map((banner, index) => (
        <BannerItem key={index} href={banner.href} target={banner.target} onClick={() => handleClick(banner)}>
          <BannerImage src={banner.src} alt={`Banner ${index + 1}`} />
        </BannerItem>
      ))}
    </BannerContainer>
  )
}

BannerGrid.propTypes = {
  banners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      src: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
    }),
  ).isRequired,

  onBannerClick: PropTypes.func.isRequired,
}

export default BannerGrid
